import { render } from "./InspectorViews.vue?vue&type=template&id=18e3f872"
import script from "./InspectorViews.vue?vue&type=script&lang=js"
export * from "./InspectorViews.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__